<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "ClaimIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
